// Settings management for game configuration

export interface GameSettings {
  model: string;
  reasoningLevel: "disabled" | "low" | "medium" | "high";
  simulateGame: boolean;
  flipMode: "none" | "alignment" | "full";
}

const DEFAULT_SETTINGS: GameSettings = {
  model: "gpt-5.1",
  reasoningLevel: "medium",
  simulateGame: false,
  flipMode: "full",
};

const AVAILABLE_MODELS = ["gpt-4o-mini", "gpt-4o", "gpt-5-mini", "gpt-5", "gpt-5.1"];

const STORAGE_KEY = "llm_mafia_game_settings";

export function loadSettings(): GameSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<GameSettings>;
      return {
        ...DEFAULT_SETTINGS,
        ...parsed,
      };
    }
  } catch (error) {
    console.warn("Failed to load settings from localStorage", error);
  }
  return DEFAULT_SETTINGS;
}

export function saveSettings(settings: GameSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (error) {
    console.warn("Failed to save settings to localStorage", error);
  }
}

export function getAvailableModels(): string[] {
  return AVAILABLE_MODELS;
}

export function getDefaultSettings(): GameSettings {
  return { ...DEFAULT_SETTINGS };
}

export function isValidModel(model: string): boolean {
  return AVAILABLE_MODELS.includes(model);
}

export function isValidReasoningLevel(level: string): level is GameSettings["reasoningLevel"] {
  return ["disabled", "low", "medium", "high"].includes(level);
}
